export default function( defaults ){

	defaults.close = {
		button: {
			template: '<a class="finalBoxClose">🞬</a>',
			container: 'first-child',    // `outside`, `inside`, `first-child`, () => Element
			position: 'afterbegin',      // same as for insertAdjacentHTML
		},
		via: 'finalBoxClosing',          // string - to add closing className and wait for transitionend
		                                 // null - to instantly destroy
	}

	defaults.on.addEvents('close_start','close_end');

	defaults.on.open_start = function(){

		let close_params = this.params?.close;
		if( close_params.button ){

			let container = null;
			switch( close_params.button.container ){
				case 'first-child':
					container = this.wrapper.firstElementChild;
					break;
				case 'inside': 
					container = this.wrapper;
					break;
				case 'outside': 
					container = this.overlay;
			}

			if( close_params.button.container instanceof Function )
				container = close_params.button.container( this.wrapper );

			if( !container ){
				console.trace();
				throw "Cannot find container for a close button";
			}

			let template = document.createElement('template');
			template.innerHTML = close_params.button.template;
			template.content.firstChild.addEventListener(
				'click',
				() => {
					this.close();
				}
			)

			container.insertAdjacentElement( close_params.button.position, template.content.firstChild );
		}

	}

	defaults.on.open_end = function(){

		if( this.params.close ){

			this.overlay.addEventListener('click', (e) => {

				if( e.target !== this.overlay )
					return;

				this.applyEvents('close_start','finalbox');
				this.close();

			})

		}

	}

	this.prototype.close = function(){

		if( this.params.close.via ){
			this.overlay.addEventListener('transitionend', () => {
				this.applyEvents('close_end','finalbox');
				this.overlay.remove();
				this.destroy();
			})
			this.overlay.classList.add( this.params.close.via );

		} else{
			this.applyEvents('close_end','finalbox');
			this.overlay.remove();
			this.destroy();
		}

	}


}